import { FC } from 'react'
import { Button, Modal } from 'antd'
import { TDnsRecord } from '../types'

type Props = {
 record?: TDnsRecord | null
 deleting?: boolean
 onCancel: () => void
 onConfirm: () => void
}

// Delete confirmation shared by the wizard review step and DNS Records
const DeleteRecordModal: FC<Props> = ({
 record,
 deleting,
 onCancel,
 onConfirm,
}) => (
 <Modal
  visible={!!record}
  onCancel={onCancel}
  width={400}
  className="domain-delete-modal"
  footer={[
   <Button key="cancel" onClick={onCancel}>
    Cancel
   </Button>,
   <Button
    key="delete"
    type="primary"
    danger
    loading={deleting}
    onClick={onConfirm}
   >
    Delete record
   </Button>,
  ]}
 >
  <div className="modal-icon">
   <i className="fas fa-exclamation-triangle" />
  </div>
  <h3>Delete this record?</h3>
  <p className="modal-sub">
   {record
    ? `Delete the ${record.type} record for "${record.host}"? This may break email or another service relying on it.`
    : ''}
  </p>
 </Modal>
)

export default DeleteRecordModal
